export const getAdvanceAirlineList = (req)=>{
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch('/shared/api/getAdvanceAirline').then((response)=>response.json())
}